import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter as Router } from "react-router-dom"; 
import AuthenticationContextProvider from './contexts/AuthenticationContext';
import RejectionReasonsProvider  from './contexts/RejectionReasonsContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthenticationContextProvider>
      <RejectionReasonsProvider>
        <Router>
          <App />
        </Router>
    </RejectionReasonsProvider>
    </AuthenticationContextProvider>
  </React.StrictMode>
);

